export const processAttribute = attr => {
  if (
    (attr.field_type === 1 || attr.field_type === 2) &&
    attr.values?.length > 0
  ) {
    return {
      id: attr.id,
      values: attr.values.map(item => item.id),
    };
  } else if (
    (attr.field_type === 3 || attr.field_type === 4) &&
    attr.values?.length > 0
  ) {
    return {
      id: attr.id,
      values: attr.values.map(item => item),
    };
  } else if (attr.field_type === 5 && attr.values?.length > 0) {
    return {
      id: attr.id,
      values: attr.values,
    };
  } else if (
    [6, 7, 8, 9, 10, 11, 12].includes(attr.field_type) &&
    attr.values?.length > 0
  ) {
    return {
      id: attr.id,
      values: attr.values,
    };
  }
  return null; // If no conditions matched, return null
};
